export var isObjEqual = function (a, b) {
    if (!a || a.constructor !== Object)
        return false;
    if (!b || b.constructor !== Object)
        return false;
    return (Object.keys(a).length === Object.keys(b).length &&
        Object.entries(a).every(function (_a) {
            var k = _a[0], v = _a[1];
            return b[k] === v;
        }));
};
